module.exports = __webpack_public_path__ + "img/icon-time-machine-wait-hover.493d2a89.svg";